import { render } from "./Sticker.vue?vue&type=template&id=2f3a5b5d&scoped=true"
import script from "./Sticker.vue?vue&type=script&lang=js"
export * from "./Sticker.vue?vue&type=script&lang=js"

import "./Sticker.vue?vue&type=style&index=0&id=2f3a5b5d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3a5b5d"]])

export default __exports__